import defaultProperties from './default.properties';

export const environment = {
    production: false,
    ...defaultProperties
};

import 'zone.js/dist/zone-error';  // Included with Angular CLI.
